<div class="addressSearch-container">
  <form (submit)="addressInputSubmit()">
    <div class="input-outline" [ngClass]="{'invalid-p-inputtext': (addressType === eAddrSysFlag.Predefined ? (addressSearchValue && (allPredefinedPlaces | filterAddress:addressSearchValue).length === 0) : locationNotFound) || errorIcon}">
      <i class="icon-search" *ngIf="isHomePage"></i>
      <span class="p-float-label">
        <input class="inputFielsTruncateText" id="address" type="text" pInputText [(ngModel)]="addressSearchValue"
          name="addressSearchValue" (ngModelChange)='changed($event)' #addressSearch autocomplete="off">
        <label for="address">{{addressSearchValue && !isHomePage ? ('label.delivery.address' | translate) :
          ('hint.search.address' | translate) }}</label>
      </span>
      <i class="icon-times" *ngIf="addressSearch.value" (click)="removeAddress()"></i>
      <i class="icon-alert" *ngIf="errorIcon || (addressType === eAddrSysFlag.Predefined ? (addressSearchValue && (allPredefinedPlaces | filterAddress:addressSearchValue).length === 0) : locationNotFound)"></i>
      <app-button [iconName]="'icon-navigation'" [disabled]="isCurrentLocationLoading"
        [class.location-loading]="isCurrentLocationLoading" (onClickEvent)="searchCurrentLocation()"
        class="navigation-btn"></app-button>
    </div>

    <div class="invalid-feeback" *ngIf="locationNotFound && addressType !== eAddrSysFlag.Predefined">
      {{'error.address.selected.cannot.detect.location'| translate }}
    </div>

    <div class="invalid-feeback"
      *ngIf="addressType === eAddrSysFlag.Predefined && addressSearchValue && locationNotFound">
      {{'no.address.found' | translate}}
    </div>
  </form>

  <div class="pac-container" [ngStyle]="{'display': displayPlaceLayout ? 'unset' : 'none'}">
    <div class="pac-content">
      <div class="pac-item" *ngFor="let place of placeList, let i = index" [ngClass]="{'no-top-padding': i ===  0}"
        (click)="selectAddress(place.addressId, place.type)">
        {{place.fullAddress}}
      </div>
    </div>
  </div>
</div>
